const expertStatusList = [
  { label: '优秀', value: '1' },
  { label: '良好', value: '2' },
  { label: '合格', value: '3' },
  { label: '不合格', value: '4' },
  { label: '缺勤', value: '5' }
]

const expertStatusMap = {
  '1': '优秀',
  '2': '合格',
  '3': '不合格'
}

export { expertStatusList, expertStatusMap }
